import React from 'react'
import { Link } from 'react-router-dom'
import footerLogo from '../../src/images/footer-logo.svg'
import { useLanguage } from '../context/LanguageContext'
import { translations } from '../translations/translations'

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className='main-footer'>
     <div className="container">
     <div className="top">
        <div className="left">
          <Link className='link' target='_blank' to='https://www.manager.avopla.ca/' rel="noopener noreferrer">
          {t.footer.signIn}
          </Link>
          <Link className='link' target='_blank' to='https://avopla.com/legal/privacy-policy' rel="noopener noreferrer">
          {t.footer.privacyPolicy}
          </Link>
          <Link className='link' target='_blank' to='https://avopla.com/legal/terms-and-conditions' rel="noopener noreferrer">
          {t.footer.termsOfUse}
          </Link>
          <Link to='/plans' className='link'>
          {t.footer.ourPlans}
          </Link>
        </div>
        <Link to='/registration' className="button">
        {t.footer.contactUs}
        </Link>
      </div>
      <div className="copy">
      <img src={footerLogo} alt="Avopla Logo" />
  <div className="text">{t.footer.copyright}</div>
      </div>
     </div>
    </div>
  )
}

export default Footer